// extracted by mini-css-extract-plugin
export default {"wrap":"ModalSelectDeliveryInterval_wrap__H5csM"};